/**
 * api.js — API client for Hypha.
 * MVP: auth functions are stubs (authed=false always).
 * When magic link auth is added, swap stubs for real implementations.
 */

import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// --- Waitlist ---
export async function joinWaitlist(email, source = "landing") {
  return axios.post(`${API}/waitlist`, { email, source });
}

// --- Protect Banner (email collection) ---
// MVP: stores email in waitlist with source "protect_banner"
export async function requestMagicLink(email, name, localEntries) {
  return axios.post(`${API}/waitlist`, {
    email,
    name,
    source: "protect_banner",
  });
}

// --- Entry stubs (for future auth) ---
export async function createEntry(text, date) {
  // Will be: axios.post(`${API}/entries`, { text, date }, authHeader())
  return { data: { text, date } };
}

export async function getTodayEntry(dateKey) {
  // Will be: axios.get(`${API}/entries/today?date=${dateKey}`, authHeader())
  return { data: null };
}

export async function listEntries(skip = 0, limit = 20, search = "") {
  // Will be: axios.get(`${API}/entries`, { params: { skip, limit, search }, ...authHeader() })
  return { data: { entries: [], total: 0 } };
}

// --- Profile stubs (for future auth) ---
export async function updateMe(data) {
  // Will be: axios.patch(`${API}/auth/me`, data, authHeader())
  return { data };
}
